import { useState } from 'react';
import {  UseFormRegister } from 'react-hook-form';
import useAppState from '../../context/AppContext';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import { initSmsSignatureCode } from '../../services/CustomerApiService';
import { handleKeyDown } from '../../utils/utils';
export type SignatureFormData = {
    validationCode: string;
 
}

type InfoSignatureConfirmTemplateProps = {
    register: UseFormRegister<any>;
    errors: any, 
    attempts: number,
    setAttempts: (tryTime: number) => void;
    
}

export default function REInfoSignatureConfirmTemplate({register, errors, attempts, setAttempts} : Readonly<InfoSignatureConfirmTemplateProps>) {

  const {
    state: { proposition, jwtToken, phoneNumberSMS },
    dispatch,
  } = useAppState();

 
  const [isClickable, setIsClickable] = useState<boolean>(true);
  const [timer, setTimer ] = useState<number>(60);


    const handleClick = async () => {
      setIsClickable(false);
      setAttempts(3);
      const token = jwtToken!.accessToken;
      const res = await initSmsSignatureCode(token, proposition!.propositionId, phoneNumberSMS);

      dispatch({type: 'INIT_SMS', sessionUid: res.data.sessionUid});

      let interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);

      setTimeout(() => {
        setIsClickable(true);
        setTimer(60);
        clearInterval(interval)
      }, 60000);
    }

    const onKeyDown  = (event : any) => {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    }

    return (          
            <form style={{width: '100%'}}>       
                <div className="form-row">          
                    <div className="form-group mw-33">
                        <MgpFormInput
                            label="Votre code d'authentification"
                            id="validationCode"
                            labelFontWeight='regular'
                            register={register} 
                            errors={errors}
                            required={true}
                            onKeyDown={onKeyDown}
                        />
                    </div>  
                </div>  
                <div className='form-row'>
                  <div className="form-group mw-33">
                    <p className='bg-menthe blanc p-xs grid-flex va-center jc-start'>
                      <i className='icon-info blanc '></i><span>Vous avez <strong>{attempts}</strong> tentatives</span>
                    </p>
                  </div>
                </div>
                 
                
                {isClickable ? <p className='p-y-md'>Vous n'avez pas reçu le code ? <button className="link clickableEl" onClick={handleClick} onKeyDown={(e) => handleKeyDown(e)}>Cliquez ici pour reçevoir un nouveau code</button></p> : <p className='p-y-md'><span>Vous pouvez demander un nouveau code dans {timer} secondes</span></p>}
                            
          
            </form>
  )
}
